import _DTO from "./_DTO";

export default class UserChannelsDTO extends _DTO {

  constructor(userChannels) {
    super();
    this.channel1 = userChannels.channel1;
    this.channel2 = userChannels.channel2;
  }
}
